import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppsIcon = ({
  title
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "vertical-nav-icon__apps",
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, /*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_114_239)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.6869 3.73471L8.38402 0.0984518C8.27978 0.0368779 8.15421 3.05176e-05 8.02039 3.05176e-05C7.88658 3.05176e-05 7.76101 0.0363931 7.65337 0.0999063L7.65677 0.0979669L1.35393 3.73422C1.1406 3.86464 1 4.09639 1 4.36111V11.637C1.00097 11.9046 1.14545 12.1383 1.36023 12.2654L1.36363 12.2673L7.66646 15.9035C7.7707 15.9642 7.89628 16 8.03009 16C8.1639 16 8.28948 15.9642 8.39711 15.9016L8.39372 15.9035L14.6966 12.2673C14.9147 12.1383 15.0592 11.9046 15.0602 11.637V4.3645C15.0573 4.09494 14.9089 3.86076 14.6903 3.73616L14.6869 3.73422V3.73471ZM8.02524 1.5675L12.8736 4.36499L8.02524 7.16248L3.1769 4.36499L8.02524 1.5675ZM2.4545 5.62556L7.29799 8.42305V14.0132L2.44965 11.2157L2.4545 5.62556ZM8.75734 14.0132V8.42305L13.596 5.62556V11.2157L8.75734 14.0132Z",
        fill: "#DFE3EB"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_114_239",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })
    })]
  });
};
export default AppsIcon;